import { c as _c } from "react/compiler-runtime";
import { NewPopover } from "@website/ui/new-popover";
import { useTooltip } from "@website/ui/tooltip/tooltip.hook";
import styles from "@website/ui/tooltip/tooltip.module.scss";
import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
export function Tooltip(properties) {
  const $ = _c(23);
  const {
    title,
    children,
    placement,
    color,
    variant,
    className,
    titleClassName
  } = properties;
  const {
    isOpen,
    direction,
    cancelClose,
    hide,
    titleProperties,
    tooltipProperties
  } = useTooltip(properties);
  const t0 = placement || "bottom";
  let t1;
  if ($[0] !== t0) {
    t1 = [t0, "top", "bottom", "right", "left"];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `var(--color-on-surface-${color === "secondary" ? "secondary-" : ""}medium-emphasis)`;
  const t3 = `${titleClassName || ""} ${styles.title} ${styles[color || "neutral"]} ${styles[variant || "wrap"] || ""}`;
  let t4;
  if ($[2] !== t3 || $[3] !== title || $[4] !== titleProperties) {
    t4 = <span className={t3} {...titleProperties}>{title}</span>;
    $[2] = t3;
    $[3] = title;
    $[4] = titleProperties;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== cancelClose || $[7] !== direction || $[8] !== hide || $[9] !== t4) {
    t5 = <div dir={direction} onMouseEnter={cancelClose} onMouseLeave={hide}>{t4}</div>;
    $[6] = cancelClose;
    $[7] = direction;
    $[8] = hide;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== tooltipProperties) {
    t6 = <div className={styles.tooltip} {...tooltipProperties}>{children}</div>;
    $[11] = children;
    $[12] = tooltipProperties;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isOpen || $[15] !== t1 || $[16] !== t2 || $[17] !== t5 || $[18] !== t6) {
    t7 = <NewPopover mode="tooltip" isOpen={isOpen} positions={t1} arrowColor={t2} panel={t5}>{t6}</NewPopover>;
    $[14] = isOpen;
    $[15] = t1;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== className || $[21] !== t7) {
    t8 = <div className={className}>{t7}</div>;
    $[20] = className;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}